"use client";

import { useEffect, useRef } from "react";
import { trackViewContent } from "@/lib/metaPixel";

export default function TrackEventView({ event }) {
  const trackedRef = useRef(false);

  useEffect(() => {
    if (!event || trackedRef.current) return;
    trackedRef.current = true;

    trackViewContent({
      eventId: event.id,
      eventName: event.name || event.title,
      category:
        event.category?.name ||
        (Array.isArray(event.activity_types)
          ? event.activity_types[0]
          : undefined),
      price: typeof event.price === "number" ? event.price : Number(event.amount) || undefined,
      currency: event.currency || "INR",
    });
  }, [event?.id]);

  return null;
}
